import React from 'react';
import { Button, Input } from 'app/components';
import { CircleNotch } from '@phosphor-icons/react';

const CreateAccount = ({ email, name, onNameChange, nameValidationMsg, onCreateAccount, isLoading }) => (
  <div className="flex flex-col w-full flex-1">
    <div className="text-2xl font-semibold">Almost there!</div>
    <div className="text-sm sm:text-base pt-2">Finish creating your account to start buying and selling tickets.</div>
    <Input
      className="pt-6"
      label="Name"
      key="user-name"
      type="text"
      width="100%"
      value={name}
      onChange={onNameChange}
      {...(nameValidationMsg && ({ validationStatus: 'error', helpText: nameValidationMsg }))}
    />
    <Input
      className="pt-6"
      label="Email"
      key="user-email"
      width="100%"
      type={email}
      value={email}
      disabled={true}
    />
    <Button
      className="mx-auto mt-6"
      onClick={() => onCreateAccount()}
      disabled={isLoading}
    >
      {isLoading ? (
        <CircleNotch
          className="loader-icon"
          size={20}
          color="#B7B7B7"
        />
      ) : 'Create account'}
    </Button>
  </div>
);

export default CreateAccount;
